import script from "./property-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./property-detail.vue?vue&type=script&setup=true&lang=js"

import "./property-detail.vue?vue&type=style&index=0&id=7e10e5db&lang=css"

const __exports__ = script;

export default __exports__